import React from 'react'
import { Link, NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { DropdownItem } from 'reactstrap'

function NotificationDisplay({ Linkdata, notiData, notiDesc }) {
    const truncate = (str) => {
        return str.length > 10 ? str.substring(0, 30) + "..." : str;
    }
    return (
        // `/admin/Total-Orders/Single-Order/${notiData.orderId}`
        // A new order has been recieved in the system.

        <Link to={`${Linkdata}`} >
            <NavLink tag="li" className="border-2 mx-2  " style={{ backgroundColor: 'blueviolet', borderRadius: '12px' }}>
                <DropdownItem className="m-0 px-1">
                    <div className="d-flex  ">
                        <img alt="new order" src={notiData.mediaUrl} width={20} />
                        <div>

                            <p className="text-white  ml-2
                              
                          " style={{ textOverflow: 'ellipsis' }}>{truncate(`${notiDesc}`)}

                            </p>
                        </div>
                    </div>
                </DropdownItem>

            </NavLink>
        </Link>
    )
}

export default NotificationDisplay